class StartNewFNOL_PSA {
    constructor($state, $scope, UserService, $stateParams) {
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
    }

    isOnPolicyViewState() {
        return this.$state.includes('policies.detail');
    }

    getPolicyNumberFromStateParams() {
        return this.$stateParams.policyNumber;
    }
}

StartNewFNOL_PSA.$inject = ['$state', '$scope', 'UserService', '$stateParams'];

export default StartNewFNOL_PSA;

